import React, {Component} from "react";
import {Form, Input , Radio,Row,Col,Checkbox,InputNumber,Upload,message,Spin,Icon,Modal } from 'antd';
import NHFormItem from '../../common/NHFormItem';
import NHFetch from "../../../utils/NHFetch";

const { TextArea } = Input;

/**
 * 绿色通道编辑表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount(){

    }

    componentDidMount(){
    }



    render() {
        const {form,initFormData} = this.props;
        let formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
        };
        const props = {
        };
 
        return (
            <div>
                <div style={{display:'none'}}>
                    <NHFormItem id={"pkid"}
                        form={this.props.form}
                        initialValue={initFormData.PKID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"xsid"} required={true} 
                        form={this.props.form}
                        initialValue={initFormData.XSID}>
                        <Input />
                    </NHFormItem>
                    <NHFormItem id={"nd"} required={true} 
                        form={this.props.form}
                        initialValue={initFormData.ND}>
                        <Input />
                    </NHFormItem>
                </div>
                <Row style={{marginBottom:'36px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>
                        {initFormData.PKID?'':<span style={{marginRight:'4px',fontFamily:'SimSun',fontSize:'14px',color:'#f5222d'}}>*</span>}
                        姓名(学号)：
                    </Col>
                    <Col span={8}>{initFormData.XH?`${initFormData.XM}(${initFormData.XH})`:''}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                    <Col span={4} style={{textAlign:'right'}}>身份证号：</Col>
                    <Col span={8}>{initFormData.SFZJH}</Col>
                </Row>
                <Row style={{marginBottom:'36px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>籍贯：</Col>
                    <Col span={8}>{initFormData.JG}</Col>
                    <Col span={4} style={{textAlign:'right'}}>民族：</Col>
                    <Col span={8}>{initFormData.MZ}</Col>
                    <Col span={4} style={{textAlign:'right'}}>所住宿舍：</Col>
                    <Col span={8}>{initFormData.SZSS}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>专业(班)：</Col>
                    <Col span={8}>{initFormData.ZYMC}{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年级：</Col>
                    <Col span={8}>{initFormData.SSNJ}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>家庭住址：</Col>
                    <Col span={8}>{initFormData.JTDZ}</Col>
                    <Col span={4} style={{textAlign:'right'}}>联系电话：</Col>
                    <Col span={8}>{initFormData.SJHM}</Col>
                </Row>
                <NHFormItem id={"hjje"} required={true} label={"缓交金额"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={initFormData.HJJE}>
                    <InputNumber style={{width:'300px'}} max={9999999}
                        formatter={value=>value?`￥${value}`:''} parser={value=>value.replace('￥','')}/>
                </NHFormItem>
                <NHFormItem id={"xfhj"} required={true} label={"学费缓交"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={initFormData.XFHJ}>
                    <InputNumber style={{width:'300px'}} max={9999999}
                        formatter={value=>value?`￥${value}`:''} parser={value=>value.replace('￥','')}/>
                </NHFormItem>
                <NHFormItem id={"zsfhj"} required={true} label={"住宿费缓交"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={initFormData.ZSFHJ}>
                    <InputNumber style={{width:'300px'}} max={9999999}
                        formatter={value=>value?`￥${value}`:''} parser={value=>value.replace('￥','')}/>
                </NHFormItem>
                <NHFormItem id={"hjqx"} required={true} label={"缓交期限"}
                    form={this.props.form} formItemLayout={formItemLayout} 
                    initialValue={initFormData.HJQX}>
                    <Input style={{width:'100px'}} suffix="月" />
                </NHFormItem>
                <NHFormItem id={"sqsm"} required={true} label={"申请说明"}
                            initialValue={initFormData.SQSM}
                            form={this.props.form} formItemLayout={formItemLayout}>
                    <TextArea maxLength ={80} placeholder="请填写申请理由" style={{width:'600px'}}/>
                </NHFormItem>
            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/swbl/ztxyLstd/EditForm.js